<template>
  <el-dialog
    title="选择设备"
    :visible.sync="visible"
    width="750px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <CustomerDeviceSelect
      :customerID="customerID"
      @change="customer_device_id = $event"
    >
    </CustomerDeviceSelect>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import CustomerDeviceSelect from '@/components/select/customer_device_select'

export default {
  components: {
    CustomerDeviceSelect,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    customerID: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  data() {
    return {
      visible: this.show,
      customer_device_id: 0,
    }
  },
  created() {},
  methods: {
    handleConfirm() {
      this.$emit('selected', this.customer_device_id)
      this.visible = false
    },
  },
}
</script>